import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { EasterEgg } from "@/layouts/EasterEgg";

const Footer = () => {
    const [showEasterEgg, setShowEasterEgg] = useState(false);

    return (
        <React.Fragment>
            <style>{`
                @keyframes heartbeat {
                    0%   { transform: scale(1); }
                    14%  { transform: scale(1.3); }
                    28%  { transform: scale(1); }
                    42%  { transform: scale(1.3); }
                    70%  { transform: scale(1); }
                }
                .heart-beat {
                    display: inline-block;
                    animation: heartbeat 1.3s ease-in-out infinite;
                    cursor: pointer;
                }
                @keyframes eggOverlayFadeIn {
                    0%   { opacity: 0; }
                    100% { opacity: 1; }
                }
                .easter-egg-overlay {
                    position: fixed;
                    inset: 0;
                    background: rgba(15, 23, 42, 0.75);
                    backdrop-filter: blur(4px);
                    z-index: 1100;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow-y: auto;
                    padding: 2rem 1rem;
                    animation: eggOverlayFadeIn 0.25s ease-out forwards;
                }
            `}</style>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            {new Date().getFullYear()} © Data Management Suite.
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                Crafted with{" "}
                                <i
                                    className="mdi mdi-heart text-danger heart-beat"
                                    onClick={() => setShowEasterEgg(true)}
                                    title="?"
                                ></i>{" "}
                                by DXO IT & CyberSecurity Services
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>

            {showEasterEgg && (
                <div
                    className="easter-egg-overlay"
                    onClick={(e) => {
                        if (e.target === e.currentTarget) setShowEasterEgg(false);
                    }}
                >
                    <Container fluid>
                        <EasterEgg handleClose={() => setShowEasterEgg(false)} />
                    </Container>
                </div>
            )}
        </React.Fragment>
    );
};

export default Footer;